<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-12 module-title">PAKBON INFO</div>
      <div class="col-lg-12" v-if="!barcode && !packingSlip && !error">
        <div class="product-info">
          Scan een barcode om pakbon informatie weer te geven.
        </div>
      </div>
      <div class="col-lg-12" v-if="debug">
        <div class="product-info error">
          {{debug}}
        </div>
      </div>
      <div class="col-lg-12" v-if="barcode && !packingSlip && !error">
        <div class="product-info">
          <span class="item-loader float-left"></span> Ophalen informatie {{barcode}}...
        </div>
      </div>
      <div class="col-lg-12" v-if="barcode && packingSlip && !error">
        <div class="product-info">
          <table>
            <tr>
              <th>Status</th>
              <td v-html="getPickingStatusBadge(packingSlip.pickingStatus)"></td>
            </tr>
            <tr>
              <th>Barcode</th>
              <td>{{packingSlip.barcode}}</td>
            </tr>
            <tr>
              <th>Ingepakt</th>
              <td>{{numPicked}} / {{packingSlip.items.length}}</td>
            </tr>
          </table>
        </div>
        <div class="product-info" v-for="item in packingSlip.items">
          <div class="product-info-cols">
            <div class="product-info-first-col">
              <span v-if="item.productionReceipt.localReceiptInfo" class="sequence-number" :class="getPickingStatusSequenceColorClass(item.packingStatus)">{{item.productionReceipt.localReceiptInfo.sequenceNumber}}</span>
              <span v-else class="sequence-number" :class="getPickingStatusSequenceColorClass(item.packingStatus)"></span>
              <span v-html="getPackingStatusBadge(item.packingStatus)"></span>
              <span class="barcode">{{item.productionReceipt.barcode}}</span>
            </div>
            <div class="product-info-second-col">
              <span class="product-info-item-badge" v-html="getProductionStatusBadge(item)"></span><br />
              <table>
                <tr>
                  <td colspan="2">{{item.product.productName}} {{item.variation.variationName}}</td>
                </tr>
                <tr>
                  <td>Productie:</td>
                  <td>{{item.productionDate | moment('DD-MM-YYYY') }}</td>
                </tr>
                <tr>
                  <td>Aflevering:</td>
                  <td>{{item.deliveryDate | moment('DD-MM-YYYY') }}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-12" v-if="barcode && !packingSlip && error">
        <div class="product-info error">
          {{error}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import EB from 'EB'

  const barcodeOptions = {
    allDecoders: false,
    code128: true,
    code128securityLevel: 0,
    code39: true,
    code39securityLevel: 0,
    datamatrix: true,
    aimType: EB.Barcode.AIMTYPE_TRIGGER, // AIMTYPE_CONTINUOUS_READ
    decodeFrequency: 2000,
    decodeLEDFeedback: true,
    decodeLEDFeedbackMode: EB.Barcode.LEDMODE_BOTH,
    decodeLEDTime: 300,
    decodeVolume: 5,
    decodeDuration: 200,
    hapticFeedback: true,
    lcdMode: true,
    sameSymbolTimeout: 3000,
    differentSymbolTimeout: 0
  }

  export default {
    created () {
      if (window.navigator.userAgent.match(/ TC7[05]x? /)) {
        this.scannerType = 'zebra'

        EB.Barcode.enable(barcodeOptions, this.zebraBarcodeScanned)
        EB.Application.setApplicationNotify(this.onZebraApplicationDestroy)
      } else {
        this.scannerType = 'software'
      }
    },
    beforeDestroy () {
      if (window.navigator.userAgent.match(/ TC7[05]x? /)) {
        EB.Barcode.disable()
      }
    },
    data () {
      return {
        packingSlip: null,
        error: null,
        barcode: null,
        scannerType: null,
        debug: null
      }
    },
    computed: {
      numPicked: function () {
        let numPicked = 0

        if (!this.packingSlip) {
          return numPicked
        }

        for (let item of this.packingSlip.items) {
          if (item.packingStatus === 'picked' || item.packingStatus === 'packed') {
            ++numPicked
          }
        }

        return numPicked
      }
    },
    methods: {
      onZebraApplicationDestroy: function (event) {
        switch (event.applicationEvent) {
          case EB.Application.APP_EVENT_ACTIVATED:
          case EB.Application.APP_EVENT_UICREATED:
          case EB.Application.APP_EVENT_SCREEN_ON:
            EB.Barcode.enable(barcodeOptions, this.zebraBarcodeScanned)
            console.log('activated scanner 2')
            break
          case EB.Application.APP_EVENT_SCREEN_OFF:
          case EB.Application.APP_EVENT_UIDESTROYED:
          case EB.Application.APP_EVENT_DEACTIVATED:
            EB.Barcode.disable()
            console.log('disabled scanner 2')
            break
        }
      },
      zebraBarcodeScanned: function (barcode) {
        this.fetchPackingSlipInfo(barcode.data)
      },
      fetchPackingSlipInfo: function (barcode) {
        this.barcode = barcode
        this.packingSlip = null
        this.error = null

        this.$http.get(process.env.API_URL + '/packing-slip/' + barcode).then(response => {
          this.packingSlip = response.body
        }, response => {
          if (response.status === 0) {
            this.error = 'Kan geen informatie ophalen vanaf de server, controleer de internetverbinding.'
          } else if (response.status === 404) {
            this.error = 'Geen informatie gevonden voor ' + barcode + '.'
          } else {
            this.error = 'Er heeft zich een onbekende fout voorgedaan voor ' + barcode + '.'
          }
          // do nothing
        })
      },
      getProductionStatusBadge: function (item) {
        switch (item.productionStatus) {
          case 'new':
            return '<span class="badge badge-production-status badge-new">Nieuw</span>'
          case 'cancelled':
            return '<span class="badge badge-production-status badge-cancelled">Geannuleerd</span>'
          case 'preparing_for_production':
          case 'in_production':
            return '<span class="badge badge-production-status badge-in-production">In productie</span>'
          case 'produced':
            if (item.packingStatus === 'packed') {
              return '<span class="badge badge-production-status badge-packed">Ingepakt</span>'
            }

            return '<span class="badge badge-production-status badge-produced">Geproduceerd</span>'
          default:
            return item.productionStatus
        }
      },
      getPickingStatusSequenceColorClass: function (status) {
        switch (status) {
          case 'picked':
          case 'packed':
            return 'picked'
          default:
            return 'unpicked'
        }
      },
      getPackingStatusBadge: function (status) {
        switch (status) {
          case 'not_produced':
            return '<span class="badge badge-production-status badge-new">Nieuw</span>'
          case 'unpicked':
            return '<span class="badge badge-production-status badge-in-production">Verzamelen...</span>'
          case 'picked':
            return '<span class="badge badge-production-status badge-produced">Verzameld</span>'
          case 'packed':
            return '<span class="badge badge-production-status badge-packed">Ingepakt</span>'
          case 'cancelling':
            return '<span class="badge badge-production-status badge-cancelled">Geannuleerd</span>'
          case 'cancelled':
            return '<span class="badge badge-production-status badge-cancelled">Geannuleerd</span>'
          default:
            return status
        }
      },
      getPickingStatusBadge: function (status) {
        switch (status) {
          case 'not_started':
            return '<span class="badge badge-production-status badge-new">Nieuw</span>'
          case 'picking':
            return '<span class="badge badge-production-status badge-produced">Verzamelen...</span>'
          case 'picked':
            return '<span class="badge badge-production-status badge-packed">Ingepakt</span>'
          default:
            return status
        }
      },
      getPrintStatusBadge: function (status) {
        switch (status) {
          case 'unprinted':
            return '<span class="badge badge-production-status badge-unprinted">Niet geprint</span>'
          case 'preparing':
            return '<span class="badge badge-production-status badge-printing">Wordt geprint...</span>'
          case 'printed':
            return '<span class="badge badge-production-status badge-printed">Geprint</span>'
          default:
            return status
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  a:hover {
    cursor: pointer;
  }

  .module-title {
    background-color: #17a2b8;
    color: #fff;
    font-size: 20px;
    line-height: 40px;
  }

  a:hover {
    cursor: pointer;
  }

  .product-info {
    background-color: #fff;
    margin-top: 15px;
    padding: 10px;
    width: 100%;
  }

  .product-info table {
    width: 100%;
  }

  .product-info table td,
  .product-info table th {
    vertical-align: top;
  }

  .product-info.error {
    background-color: #dc3545;
    color: #fff;
  }

  .sequence-number {
    display: inline-block;
    font-size: 40px;
    font-weight: bold;
    line-height: 100px;
    width: 100px;
    height: 100px;
    text-align: center;
  }

  .sequence-number.unpicked {
    background-color: #ff9999;
    color: #000;
  }

  .sequence-number.picked {
    background-color: #99ff99;
    color: #000;
  }

  .product-info-cols {
    display: flex;
  }

  .product-info-first-col {
    width: 100px;
    text-align: center;
    float: left;
    position: relative;
    flex-grow: 0;
  }

  .barcode {
    font-size: 13px;
  }

  .product-info-second-col {
    padding-left: 10px;
    float: left;
    flex-grow: 1;
    font-size: 14px;
  }

  .product-info-item-badge .badge {
    vertical-align: top;
  }
</style>



// WEBPACK FOOTER //
// src/components/PackingSlipInfo.vue